module.exports = "mutation DeleteSendableCard($id: ID!) {\n  deleteSendableCard(id: $id) {\n    deleted\n  }\n}\n"